import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=603ad397&scoped=true&lang=pug"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603ad397",
  null
  
)

export default component.exports